import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { AccountRequest } from "./CompanyModel/AccountRequest"
import { AccountLimit, AccountType, ImplementationGroupID_Workforce } from "../../config/Constants"
import AutoFilterCompany from "./CompanyModel/AutoFilterCompany"

export default function GetAccountsByNameObservable(query: string, showInactive: boolean = false, accountType: AccountType = AccountType.Company ): Observable<AutoFilterCompany[]> {
  const request: AccountRequest = { AccountTypeID: accountType, Name: query, Limit: AccountLimit, ImplementationGroupID: ImplementationGroupID_Workforce, ShowInactive: showInactive }
  const requestBody: string = JSON.stringify(request)
  return ObservableFromFetch<AutoFilterCompany[]>("Account/GetAllByName", requestBody)
}
export function GetAllAccountsByNameObservable(query: string, showInactive: boolean = false, accountType: AccountType = AccountType.Company ): Observable<AutoFilterCompany[]> {
  const request: AccountRequest = { AccountTypeID: accountType, Name: query, Limit: 0, ImplementationGroupID: ImplementationGroupID_Workforce, ShowInactive: showInactive }
  const requestBody: string = JSON.stringify(request)
  return ObservableFromFetch<AutoFilterCompany[]>("Account/GetAllByName", requestBody)
}
